import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import { Game, Tile, Level } from '@app/models/content';
import { ToolsService, ContentService, EventsService, TrackingService } from '@app/services/services';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Subscription } from 'rxjs';
import {TileType, Topic} from '@app/shared/enums';
import {MetatagsService} from '@app/services/metatags/metatags.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.scss']
})
export class GameComponent implements OnInit, AfterViewInit, OnDestroy {
  game: Game;
  active = false;
  subscriptions: Subscription[] = [];
  viewInit = false;
  tiles: Tile[] = [];
  levels: Level[];

  constructor(
    private tools: ToolsService,
    private content: ContentService,
    private events: EventsService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private tracking: TrackingService,
    private metaTagsService: MetatagsService
  ) {}

  ngOnInit() {
    this.tools.addBodyClass('page__game');
    this.subscriptions.push(
      this.route.paramMap.subscribe((params: ParamMap) => {
        this.getGame(params.get('id'));
      })
    );
  }

  ngAfterViewInit(): void {
    this.viewInit = true;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.tools.removeBodyClass('page__fiche');
  }

  onClick() {
    this.active = !this.active;
  }

  getGame(slug: string) {
    this.events.broadcast('loading', true);
    this.subscriptions.push(
      this.content.getGame(this.translate.currentLang, slug).subscribe(
        result => {
          if (result.errors) {
            this.redirectTo404();
          } else {
            // Todo: english test only there in case of going live in urgency
            if (environment.production && result.data.game.topic === Topic.english) {
              this.redirectTo404();
            }
            this.game = result.data.game;
            this.levels = this.content.getLevelsFile(this.game.levels);
            this.tools.setTheme(this.game.topic);
            this.events.broadcast('loading', false);
            this.fetchGameTiles();
            if (this.game.metatags) {
              this.metaTagsService.updateMetaTags(this.game.metatags);
            }
            this.game.id = result.data.game.uuid;
            this.tracking.pushVar({
              event: 'hit',
              content_type: 'game',
              content_id: this.game.id
            });
          }
        },
        error => {
          this.redirectTo404();
        }
      )
    );
  }

  redirectTo404() {
    this.events.broadcast('loading', false);
    this.router.navigate(['/404'], {replaceUrl: true});
  }

  fetchGameTiles() {
    this.subscriptions.push(
      this.content.searchFiles(
        this.translate.currentLang,
        null,
        TileType.game
      ).subscribe(results => {
        if (results.size) {
          const tempTiles = results.tiles.filter(
            tile => tile.title !== this.game.title
          );
          this.tiles = tempTiles.length > 12 ?
            tempTiles.slice(0, 12) :
            tempTiles;
        }
      })
    );
  }
}
